import { createLazyComponent, LazyModule, LazyModuleType } from 'owa-bundling';
import CommandRibbonPlaceholder from 'owa-command-ribbon/lib/components/CommandRibbonPlaceholder';
import { FullComposeRibbonProps } from './schema/FullComposeRibbonProps';

export const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "FullComposeRibbon" */ './lazyIndex')
);

export const FullComposeRibbon = createLazyComponent<
    FullComposeRibbonProps,
    LazyModuleType<typeof lazyModule>,
    {}
>(lazyModule, m => m.FullComposeRibbon, CommandRibbonPlaceholder);
